<div class='bread-crumb' *ngIf="breadCrumb$ | async as breadCrumb">
  <h2 class='bread-crumb-title'>{{breadCrumb.title}}</h2>
  <ng-container *ngFor="let crumb of breadCrumb.crumbs">
    <span *ngIf="crumb.link" class="crumb-link crumb" (click)="navigate(crumb.link)"> / {{crumb.label}} </span>
    <span *ngIf="!crumb.link" class="crumb"> / {{crumb.label}} </span>
  </ng-container>
  <hr class='bread-crumb-divider'>
</div>

